const getQueryFilterFormat = filter => {
    const handleValue2Filters=(propertyName,comparatorType,filterValues)=>{        
            let compare1="";
            let compare2="";
            let orAnd="";
            switch (comparatorType) {
                case "between": compare1="gt";compare2="lt"; orAnd="and";break;
                case "nbetween": compare1="lte";compare2="gte"; orAnd="or";break;
                case "from": compare1="gte";compare2="lte"; orAnd="and";break;
                case "nfrom": compare1="lt";compare2="gt"; orAnd="or";break;
                default: break;
            }
            return `{
               ${orAnd}:[{${propertyName}:{
                    ${compare1}: ${isNaN(parseInt(filterValues.value)) ? 0 : parseInt(filterValues.value)}
                }
            },
            {
                ${propertyName}:{
                    ${compare2}: ${isNaN(parseInt(filterValues.value2)) ? 0 : parseInt(filterValues.value2)}
                }
            }]},
            `
    }    
    switch (filter.column.dataType) {
        case 'String': return `{
            ${filter.column.propertyName}:{
                ${filter.comparator.type}:"${filter.filterValues.value}"
            }
        },
        `
        case 'Byte':
        case 'Sbyte':
        case 'Short':
        case 'Ushort':
        case 'Integer':
        case 'Uinteger':
        case 'Long':
        case 'Ulong':
        case 'Float':
        case 'Double':
        case 'Decimal':
            switch (filter.comparator.type) {
                case 'between':
                case 'nbetween':
                case 'from':
                case 'nfrom':
                    return handleValue2Filters(filter.column.propertyName,filter.comparator.type,filter.filterValues)
                default: return `{
                    ${filter.column.propertyName}:{
                        ${filter.comparator.type}:${filter.filterValues.value}
                    }
                },
                `
            }                
        case 'Boolean': return `{
            ${filter.column.propertyName}:{
                ${filter.comparator.type}:${filter.filterValues.value}
            }
        },
        `        
        default: return `{
            ${filter.column.propertyName}:{
                ${filter.comparator.type}:"${filter.filtervalues.value}"
            }
        },
        `
    }
}

export default getQueryFilterFormat
